import _objectSpread from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
export var createBaseAudioContextConstructor = function createBaseAudioContextConstructor(addAudioWorkletModule, analyserNodeConstructor, audioBufferConstructor, audioBufferSourceNodeConstructor, biquadFilterNodeConstructor, channelMergerNodeConstructor, channelSplitterNodeConstructor, constantSourceNodeConstructor, convolverNodeConstructor, _decodeAudioData, delayNodeConstructor, dynamicsCompressorNodeConstructor, gainNodeConstructor, iIRFilterNodeConstructor, minimalBaseAudioContextConstructor, oscillatorNodeConstructor, pannerNodeConstructor, periodicWaveConstructor, stereoPannerNodeConstructor, waveShaperNodeConstructor) {
  return /*#__PURE__*/function (_minimalBaseAudioCont) {
    _inherits(BaseAudioContext, _minimalBaseAudioCont);
    function BaseAudioContext(_nativeContext, numberOfChannels) {
      var _this;
      _classCallCheck(this, BaseAudioContext);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseAudioContext).call(this, _nativeContext, numberOfChannels));
      _this._nativeContext = _nativeContext;
      _this._audioWorklet = addAudioWorkletModule === undefined ? undefined : {
        addModule: function addModule(moduleURL, options) {
          return addAudioWorkletModule(_assertThisInitialized(_assertThisInitialized(_this)), moduleURL, options);
        }
      };
      return _this;
    }
    _createClass(BaseAudioContext, [{
      key: "createAnalyser",
      value: function createAnalyser() {
        return new analyserNodeConstructor(this);
      }
    }, {
      key: "createBiquadFilter",
      value: function createBiquadFilter() {
        return new biquadFilterNodeConstructor(this);
      }
    }, {
      key: "createBuffer",
      value: function createBuffer(numberOfChannels, length, sampleRate) {
        return new audioBufferConstructor({
          length: length,
          numberOfChannels: numberOfChannels,
          sampleRate: sampleRate
        });
      }
    }, {
      key: "createBufferSource",
      value: function createBufferSource() {
        return new audioBufferSourceNodeConstructor(this);
      }
    }, {
      key: "createChannelMerger",
      value: function createChannelMerger() {
        var numberOfInputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
        return new channelMergerNodeConstructor(this, {
          numberOfInputs: numberOfInputs
        });
      }
    }, {
      key: "createChannelSplitter",
      value: function createChannelSplitter() {
        var numberOfOutputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
        return new channelSplitterNodeConstructor(this, {
          numberOfOutputs: numberOfOutputs
        });
      }
    }, {
      key: "createConstantSource",
      value: function createConstantSource() {
        return new constantSourceNodeConstructor(this);
      }
    }, {
      key: "createConvolver",
      value: function createConvolver() {
        return new convolverNodeConstructor(this);
      }
    }, {
      key: "createDelay",
      value: function createDelay() {
        var maxDelayTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return new delayNodeConstructor(this, {
          maxDelayTime: maxDelayTime
        });
      }
    }, {
      key: "createDynamicsCompressor",
      value: function createDynamicsCompressor() {
        return new dynamicsCompressorNodeConstructor(this);
      }
    }, {
      key: "createGain",
      value: function createGain() {
        return new gainNodeConstructor(this);
      }
    }, {
      key: "createIIRFilter",
      value: function createIIRFilter(feedforward, feedback) {
        return new iIRFilterNodeConstructor(this, {
          feedback: feedback,
          feedforward: feedforward
        });
      }
    }, {
      key: "createOscillator",
      value: function createOscillator() {
        return new oscillatorNodeConstructor(this);
      }
    }, {
      key: "createPanner",
      value: function createPanner() {
        return new pannerNodeConstructor(this);
      }
    }, {
      key: "createPeriodicWave",
      value: function createPeriodicWave(real, imag) {
        var constraints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          disableNormalization: false
        };
        return new periodicWaveConstructor(this, _objectSpread({}, constraints, {
          imag: imag,
          real: real
        }));
      }
    }, {
      key: "createStereoPanner",
      value: function createStereoPanner() {
        return new stereoPannerNodeConstructor(this);
      }
    }, {
      key: "createWaveShaper",
      value: function createWaveShaper() {
        return new waveShaperNodeConstructor(this);
      }
    }, {
      key: "decodeAudioData",
      value: function decodeAudioData(audioData, successCallback, errorCallback) {
        return _decodeAudioData(this._nativeContext, audioData).then(function (audioBuffer) {
          if (typeof successCallback === 'function') {
            successCallback(audioBuffer);
          }
          return audioBuffer;
        }, function (err) {
          if (typeof errorCallback === 'function') {
            errorCallback(err);
          }
          throw err;
        });
      }
    }, {
      key: "audioWorklet",
      get: function get() {
        return this._audioWorklet;
      }
    }]);
    return BaseAudioContext;
  }(minimalBaseAudioContextConstructor);
};